import { render, staticRenderFns } from "./_promoItems.vue?vue&type=template&id=7829ae75&scoped=true&lang=pug&"
import script from "./_promoItems.vue?vue&type=script&lang=js&"
export * from "./_promoItems.vue?vue&type=script&lang=js&"
import style0 from "./_promoItems.vue?vue&type=style&index=0&id=7829ae75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7829ae75",
  null
  
)

export default component.exports